module.exports = __webpack_public_path__ + "static/media/in-icon.8a2cd3c2.svg";